module.exports = __webpack_public_path__ + "img/use-analytics.873dc593.svg";